import { PolicyConfigDecisionAttributeFieldResultTypes } from "@enums/policy-config-decision-attribute-field-result-type";
import { SelectOption } from "@idw-types/common";

export const POLICY_CONFIG_DECISION_ATTRIBUTE_FIELD_RESULT_OPTIONS: Array<SelectOption> = [
    { label: "MATCHES", value: PolicyConfigDecisionAttributeFieldResultTypes.MATCH },
    { label: "DOES NOT MATCH", value: PolicyConfigDecisionAttributeFieldResultTypes.NOT_MATCH },
    { label: "NOT EQUAL", value: PolicyConfigDecisionAttributeFieldResultTypes.NOT_EQUAL },
    { label: "GREATER THAN", value: PolicyConfigDecisionAttributeFieldResultTypes.GREATER_THAN },
    { label: "EQUAL TO", value: PolicyConfigDecisionAttributeFieldResultTypes.EQUAL_TO },
    { label: "LESS THAN", value: PolicyConfigDecisionAttributeFieldResultTypes.LESS_THAN },
    { label: "NULL", value: PolicyConfigDecisionAttributeFieldResultTypes.NULL },
    { label: "NOT NULL", value: PolicyConfigDecisionAttributeFieldResultTypes.NOT_NULL },
    { label: "BLANK", value: PolicyConfigDecisionAttributeFieldResultTypes.BLANK },
    { label: "NOT BLANK", value: PolicyConfigDecisionAttributeFieldResultTypes.NOT_BLANK }
];

export const policyConfigDecisionOperatorsWithNoValue = [
    PolicyConfigDecisionAttributeFieldResultTypes.NULL,
    PolicyConfigDecisionAttributeFieldResultTypes.NOT_NULL,
    PolicyConfigDecisionAttributeFieldResultTypes.BLANK,
    PolicyConfigDecisionAttributeFieldResultTypes.NOT_BLANK,
];